import { Switch, Field, Label } from "@headlessui/react";
import { XIcon, CheckIcon } from "@phosphor-icons/react";
import clsx from "clsx";

export default function ToggleSwitch({
	enabled,
	setEnabled,
	label,
	displayLabel = true,
}: {
	enabled: boolean;
	setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
	label: string;
	displayLabel?: boolean;
}) {
	return (
		<Field className="eF-flex eF-items-center eF-justify-between eF-gap-2">
			{displayLabel && (
				<Label as="span" className="eF-text-sm hover:eF-cursor-pointer">
					{label.length > 0 ? (
						<span className="eF-font-medium eF-text-gray-900">{label}</span>
					) : (
						<span className="eF-text-[0.9rem] eF-text-gray-500">
							I understand this has no impact on my credit score and agree to the{" "}
							<a
								className="eF-text-[--eF-theme-color] eF-font-semibold"
								href="/privacy-policy"
								target="_blank"
							>
								terms & conditions
							</a>
							.
						</span>
					)}
				</Label>
			)}
			<Switch
				checked={enabled}
				onChange={setEnabled}
				className={clsx(
					enabled ? "" : "eF-bg-gray-200",
					`eF-relative eF-inline-flex eF-h-6 eF-w-11 eF-flex-shrink-0 eF-cursor-pointer eF-rounded-full eF-border-2 eF-border-[--eF-theme-color] eF-transition-colors eF-duration-200 eF-ease-in-out focus:eF-outline-none focus:eF-ring-2 focus:eF-ring-offset-2`
				)}
				style={
					{
						backgroundColor: enabled ? "var(--eF-theme-color)" : "",
						"--tw-ring-color": "var(--eF-theme-color)",
					} as React.CSSProperties
				}
			>
				<span className="eF-sr-only">Use setting</span>
				<span
					className={clsx(
						enabled ? "eF-translate-x-5" : "eF-translate-x-0",
						"eF-pointer-events-none eF-relative eF-inline-block eF-h-5 eF-w-5 eF-transform eF-rounded-full eF-bg-white eF-shadow eF-ring-0 eF-transition eF-duration-200 eF-ease-in-out"
					)}
				>
					<span
						className={clsx(
							enabled
								? "eF-opacity-0 eF-duration-100 eF-ease-out"
								: "eF-opacity-100 eF-duration-200 eF-ease-in",
							"eF-absolute eF-inset-0 eF-flex eF-h-full eF-w-full eF-items-center eF-justify-center eF-transition-opacity"
						)}
						aria-hidden="true"
					>
						<XIcon
							className="eF-h-3 eF-w-3 eF-stroke-[--eF-theme-color] eF-stroke-[10%]"
							size={32}
						/>
					</span>
					<span
						className={clsx(
							enabled
								? "eF-opacity-100 eF-duration-200 eF-ease-in"
								: "eF-opacity-0 eF-duration-100 eF-ease-out",
							"eF-absolute eF-inset-0 eF-flex eF-h-full eF-w-full eF-items-center eF-justify-center eF-transition-opacity"
						)}
						aria-hidden="true"
					>
						<CheckIcon
							className="eF-h-3 eF-w-3 eF-stroke-[--eF-theme-color] eF-stroke-[10%]"
							size={32}
						/>
					</span>
				</span>
			</Switch>
		</Field>
	);
}
